import { ViewFactory } from 'cube-react'

import AnaliseReacoesScope from '../analise-reacoes.scope'
import AnaliseReacoesView from './v-analise-reacoes'

export function registerViews(rr: typeof ViewFactory['register']) {
    rr(AnaliseReacoesScope, AnaliseReacoesView)
}